import React, { useState } from "react";
import { MapPin, Building2, X } from "lucide-react";
import TiltCard from "./TiltCard";
import { SectionTitle } from "./PageBanner";
import { hqPhotos, hqContact } from "../data/mock";

// Registered office photo mosaic (portrait-friendly) with lightbox
export default function HQGallery({ compact = false }) {
  const [active, setActive] = useState(null);
  if (!hqPhotos.length) return null;
  return (
    <section style={{ padding: compact ? "0 24px 60px" : "30px 24px 50px" }} data-testid="hq-gallery">
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <SectionTitle>Registered Office &amp; Building</SectionTitle>
        <div style={{ display: "grid", gridTemplateColumns: compact ? "1fr" : "1.5fr 1fr", gap: 24, alignItems: "stretch" }} className="two-col">
          <div className="hq-mosaic" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridAutoRows: compact ? 150 : 170, gap: 12 }}>
            {hqPhotos.map((p, i) => (
              <TiltCard key={i} intensity={5} className={i === 0 ? "hq-wide" : ""}>
                <div data-testid={`hq-photo-${i}`} onClick={() => setActive(p)} style={{ position: "relative", width: "100%", height: "100%", overflow: "hidden", borderRadius: 18, cursor: "pointer" }}>
                  <img src={p.url} alt={p.title} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: p.pos || "center", transition: "transform 600ms" }} onMouseEnter={e => e.currentTarget.style.transform = "scale(1.07)"} onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"} />
                  <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, transparent 55%, rgba(124,45,18,0.85))" }} />
                  <div style={{ position: "absolute", left: 12, right: 12, bottom: 10, color: "#fff", fontSize: 12.5, fontWeight: 700, lineHeight: 1.3 }}>{p.title}</div>
                </div>
              </TiltCard>
            ))}
          </div>
          {!compact && (
            <div className="premium-card" style={{ padding: 26, display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div className="icon-tile"><Building2 size={20} /></div>
                <div>
                  <div style={{ fontSize: 11, color: "#EA580C", fontWeight: 800, letterSpacing: 1 }}>REGISTERED OFFICE</div>
                  <div style={{ fontSize: 15, color: "#1C1917", fontWeight: 600, lineHeight: 1.5, marginTop: 4 }}>Ground Floor, Phycare Building, Plot No. 9, IT Park, Mangalagiri – 522503, Guntur District, Andhra Pradesh</div>
                  <div style={{ fontSize: 12.5, color: "#78716C", marginTop: 6 }}>CIN: U74999AP2021SGC117458 · An Enterprise of Government of Andhra Pradesh</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginTop: 18 }}>
                <div className="icon-tile icon-tile-yellow"><MapPin size={20} /></div>
                <div>
                  <div style={{ fontSize: 11, color: "#EA580C", fontWeight: 800, letterSpacing: 1 }}>DIRECTORATE</div>
                  <div style={{ fontSize: 15, color: "#1C1917", fontWeight: 600, lineHeight: 1.5, marginTop: 4 }}>{hqContact.address2}</div>
                </div>
              </div>
              <a href="https://www.google.com/maps/search/?api=1&query=Phycare+Building,+Plot+No+9,+IT+Park,+Mangalagiri,+Guntur" target="_blank" rel="noreferrer" className="btn-outline-3d" data-testid="hq-directions-btn" style={{ marginTop: 22, textDecoration: "none", alignSelf: "flex-start" }}>Get Directions</a>
            </div>
          )}
        </div>
      </div>

      {active && (
        <div onClick={() => setActive(null)} data-testid="hq-lightbox" style={{ position: "fixed", inset: 0, background: "rgba(67,20,7,0.88)", backdropFilter: "blur(6px)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div onClick={e => e.stopPropagation()} style={{ maxWidth: "min(92vw, 720px)", maxHeight: "90vh", background: "#fff", borderRadius: 20, overflow: "hidden", position: "relative", boxShadow: "0 40px 80px rgba(0,0,0,0.5)", animation: "fadeUp 350ms ease-out" }}>
            <button data-testid="hq-lightbox-close" onClick={() => setActive(null)} style={{ position: "absolute", right: 12, top: 12, background: "#DC2626", color: "#fff", border: "none", borderRadius: 10, padding: 8, cursor: "pointer", zIndex: 2 }}><X size={16} /></button>
            <img src={active.url} alt={active.title} style={{ display: "block", maxWidth: "100%", maxHeight: "78vh", objectFit: "contain", margin: "0 auto", background: "#1C1917" }} />
            <div style={{ padding: "12px 18px", fontWeight: 700, color: "#1C1917", fontSize: 14 }}>{active.title}</div>
          </div>
        </div>
      )}
      <style>{`
        .hq-mosaic .hq-wide { grid-column: span 2; grid-row: span 2; }
        @media (max-width: 640px) { .hq-mosaic { grid-template-columns: repeat(2, 1fr) !important; grid-auto-rows: 140px !important; } }
      `}</style>
    </section>
  );
}
